import { ActionTree } from 'vuex';
import {
  EMoveResourceAction,
  EMoveResourceMutation,
  state as defaultState,
} from './move-resource.constants';
import { IMoveResourceState } from './move-resource.types';
import { translate } from '@/helpers/translation.helper';
import { RootState } from '@/store/store';
import { IResource } from '@/api/resources/types/resource';
import { ResourceService } from '@/api/resources/services/resource.service';
import { IUpdateResourceDTO } from '@/api/resources/dtos/update-resource-dto';

export const actions: ActionTree<IMoveResourceState, RootState> = {
  async [EMoveResourceAction.Load]({ commit, dispatch }, id: string) {
    commit(EMoveResourceMutation.SetLoading, true);
    commit(EMoveResourceMutation.SetLoaded, false);
    try {
      const resource: IResource = await ResourceService.loadDetails(id);
      dispatch(EMoveResourceAction.LoadSuccess, resource);
    } catch (error) {
      dispatch(EMoveResourceAction.LoadFailed);
    }
  },
  [EMoveResourceAction.LoadSuccess]({ commit }, resource: IResource) {
    commit(EMoveResourceMutation.SetResource, resource);
    commit(EMoveResourceMutation.SetLoading, false);
    commit(EMoveResourceMutation.SetLoaded, true);
  },
  [EMoveResourceAction.LoadFailed]({ dispatch, commit }) {
    commit(EMoveResourceMutation.SetResource, { ...defaultState }.resource);
    commit(EMoveResourceMutation.SetLoading, false);
    commit(EMoveResourceMutation.SetLoaded, false);
    dispatch('alert/showDangerAlert', translate('could-not-load-resource'), {
      root: true,
    });
  },
  async [EMoveResourceAction.Move]({ commit, dispatch }, payload: IUpdateResourceDTO) {
    commit(EMoveResourceMutation.SetMoving, true);
    try {
      const movedResource: IResource = await ResourceService.update(payload);
      dispatch(EMoveResourceAction.MoveSuccess, movedResource);
    } catch (error) {
      dispatch(EMoveResourceAction.MoveFailed);
    }
  },
  [EMoveResourceAction.MoveSuccess]({ commit }, movedResource: IResource) {
    commit(EMoveResourceMutation.SetMovedResource, movedResource);
    commit(EMoveResourceMutation.SetMoving, false);
  },
  [EMoveResourceAction.MoveFailed]({ dispatch, commit }) {
    commit(EMoveResourceMutation.SetMovedResource, { ...defaultState }.movedResource);
    commit(EMoveResourceMutation.SetMoving, false);
    dispatch('alert/showDangerAlert', translate('could-not-update-resource'), {
      root: true,
    });
  },
  [EMoveResourceAction.Reset]({ commit }) {
    commit(EMoveResourceMutation.SetState, { ...defaultState });
  },
};
